var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login hero is-white is-halfheight"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-6 is-offset-3"},[_c('div',{staticClass:"box"},[_c('Form')],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }